// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock.saleThroughputReports', {
        url: '/salethroughputreports',
        views: {
            "wideColumnView@stock": {
                templateUrl: 'main/stock/reports/saleThroughputReports.tpl.html',
                controller: 'SaleThroughputReportsController as vm'
            }
        },
        resolve: {
            brands: brandsResolver,
            collections: collectionsResolver,
            locations: locationsResolver,
            departments: departmentsResolver
        }
    });
}

// @ngInject
function brandsResolver(StockApiService) {
    return StockApiService.getFilteredBrands();
}

// @ngInject
function collectionsResolver(StockApiService) {
    return StockApiService.getCollections();
}

// @ngInject
function locationsResolver(StockApiService) {
    return StockApiService.getFilteredLocations();
}

// @ngInject
function departmentsResolver(StockApiService) {
    return StockApiService.getDepartments();
}


// @ngInject
function SaleThroughputReportsController($translate, StockApiService, brands, loadSpinnerService, collections, locations, ToasterService, departments) {
    var vm = this;

    vm.reportParameters = {
        startDate: new Date(1970, 1, 1, 0, 0, 0),
        endDate: new Date(),
        brandId: undefined,
        collectionId: undefined,
        includeIsCurrent: false
    };

    vm.brands = brands;
    vm.collections = collections;
    vm.locations = locations;
    vm.departments = departments;
    vm.groupings = [
        { id: 0, label: $translate.instant('reports.groupingProduct'), grouping: 'Product' },
        { id: 1, label: $translate.instant('reports.groupingProductLocation'), grouping: 'ProductLocation' },
        { id: 2, label: $translate.instant('reports.groupingVariantDetail1'), grouping: 'VariantDetail1' },
        { id: 3, label: $translate.instant('reports.groupingVariantDetail1Location'), grouping: 'VariantDetail1Location' },
        { id: 4, label: $translate.instant('reports.groupingVariantDetail1VariantDetail2'), grouping: 'VariantDetail1VariantDetail2' },
        { id: 5, label: $translate.instant('reports.groupingVariantDetail1VariantDetail2Location'), grouping: 'VariantDetail1VariantDetail2Location'},
        { id: 6, label: $translate.instant('reports.groupingBrand'), grouping: 'Brand'}
    ];
    vm.selectedGrouping = vm.groupings[0];

    vm.selectedCollections = [];
    vm.selectedBrands = [];
    vm.selectedLocations = [];
    vm.selectedDepartments = [];

    vm.switchToCsv = switchToCsv;
    vm.switchToPdf = switchToPdf;
 
    vm.fileFormatChoice = {
        csv: true,
        pdf: false
    };

    //Methods
    vm.getSaleThroughputReport = getSaleThroughputReport;
    
    activate();

    function activate() {
        _.forEach(vm.locations, function(location) {
            vm.selectedLocations.push(location);
        });
        _.forEach(vm.departments, function(department) {
            vm.selectedDepartments.push(department);
        });
    }

    function getSaleThroughputReport() {
        if (!validateRequest()) {
            return;
        }

        var request = {
            endDate: vm.reportParameters.endDate,
            brandIds: [],
            collectionIds: [],
            locationIds: [],
            departmentIds: [],
            grouping: vm.selectedGrouping.grouping,
            includeIsCurrent: vm.reportParameters.includeIsCurrent,
            startDate: vm.reportParameters.startDate
        };

        _.forEach(vm.selectedBrands, function(brand) { request.brandIds.push(brand.id); });
        _.forEach(vm.selectedCollections, function (collection) { request.collectionIds.push(collection.id); });
        _.forEach(vm.selectedLocations, function(location) { request.locationIds.push(location.id); });
        _.forEach(vm.selectedDepartments, function(department) { request.departmentIds.push(department.id); });

        loadSpinnerService.start("mainSpinner");
        if (vm.fileFormatChoice.csv) {
            StockApiService.downloadSaleThroughputReport(request).finally(function () {
                loadSpinnerService.stop("mainSpinner");
            });
        } else if (vm.fileFormatChoice.pdf) {
            StockApiService.downloadSaleThroughputReportPdf(request).finally(function () {
                loadSpinnerService.stop("mainSpinner");
            });
        }

    }

    function validateRequest() {
        if (vm.selectedBrands.length === 0) {
            ToasterService.showWarning($translate.instant('reports.error.needToSelectBrands'));
            return false;
        }
        if (vm.selectedCollections.length === 0) {
            ToasterService.showWarning($translate.instant('reports.error.needToSelectCollections'));
            return false;
        }
        if (vm.selectedLocations.length === 0) {
            ToasterService.showWarning($translate.instant('reports.error.needToSelectLocations'));
            return false;
        }
        // if (vm.selectedDepartments.length === 0) {
        //     ToasterService.showWarning($translate.instant('reports.error.needToSelectDepartments'));
        //     return false;
        // }
        return true;
    }

    function switchToCsv() {
        var keys = Object.keys(vm.fileFormatChoice);
        _.forEach(keys, function(key) { vm.fileFormatChoice[key] = false; });
        vm.fileFormatChoice.csv = true;
    }

    function switchToPdf() {
        var keys = Object.keys(vm.fileFormatChoice);
        _.forEach(keys, function(key) { vm.fileFormatChoice[key] = false; });
        vm.fileFormatChoice.pdf = true;
    }

}

angular.module('stock.saleThroughputReports', [])
    .config(stateConfig)
    .controller('SaleThroughputReportsController', SaleThroughputReportsController);
